package com.tregz.tremenz.ui.screen

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.material3.MaterialTheme
import androidx.compose.foundation.selection.toggleable
import androidx.compose.ui.semantics.Role
import androidx.compose.material3.Switch
import androidx.compose.material3.SwitchDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.tregz.tremenz.io.model.ModelData
import com.tregz.tremenz.io.model.ModelRepository
import com.tregz.tremenz.ui.component.CardMedia
import com.tregz.tremenz.ui.component.StatusNotice
import com.tregz.tremenz.ui.label.LabelKey
import com.tregz.tremenz.ui.label.labelText

/** The Tracks destination: the `miksing-export.json` songs, played back to back when mixed. */
@Composable
fun ScreenTracks(
    currentMedia: ModelData.Media?,
    isSongPlaying: Boolean,
    isPreparingSong: Boolean,
    isContinuousMix: Boolean,
    onContinuousMixToggle: (Boolean) -> Unit,
    onPlayMedia: (ModelData.Media) -> Unit,
    modifier: Modifier = Modifier
) {
    val scheme = MaterialTheme.colorScheme
    val songsList by ModelRepository.SONGS_LIVE.collectAsState()
    val status by ModelRepository.SONGS_STATUS.collectAsState()

    // Cards stay one per row until the pane can hold two of them side by side.
    LazyVerticalGrid(
        columns = GridCells.Adaptive(minSize = 400.dp),
        modifier = modifier
            .fillMaxWidth()
            .wrapContentWidth(Alignment.CenterHorizontally)
            .widthIn(max = 1200.dp)
    ) {
        // Header: Continuous mix switch
        item(span = { GridItemSpan(maxLineSpan) }) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .toggleable(
                        value = isContinuousMix,
                        role = Role.Switch,
                        onValueChange = onContinuousMixToggle
                    )
                    .padding(horizontal = 16.dp, vertical = 8.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Text(
                    text = labelText(LabelKey.CONTROL_CONTINUOUS_MIX),
                    color = scheme.onBackground,
                    style = MaterialTheme.typography.titleMedium
                )
                Switch(
                    checked = isContinuousMix,
                    onCheckedChange = null,
                    colors = SwitchDefaults.colors(
                        checkedThumbColor = scheme.onPrimary,
                        checkedTrackColor = scheme.primary
                    )
                )
            }
        }

        if (songsList.isEmpty()) {
            item(span = { GridItemSpan(maxLineSpan) }) {
                StatusNotice(status = status, onRetry = ModelRepository::retry)
            }
        }

        items(songsList, key = { it.id }) { song ->
            val isCurrentSong = currentMedia == song
            CardMedia(
                media = song,
                isPlaying = isCurrentSong && isSongPlaying,
                isPreparing = isCurrentSong && isPreparingSong,
                onPlayClick = {
                    // Starting here hands continuous playback back to the whole catalogue, in case
                    // a channel from the Channels tab was the queue until now.
                    ModelRepository.setActiveSongs(songsList)
                    onPlayMedia(song)
                }
            )
        }
    }
}
